export const styles = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  display: 'flex',
  flexDirection: 'column',
  transform: 'translate(-50%, -50%)',
  width: '35%',
  backgroundColor: '#fff',
  border: 'none',
  outline: 'none',
  borderRadius: '8px',
  padding: '16px',
  height: 'fit-content',
  maxHeight: '80vh',
  justifyContent: 'center',
  zIndex: 95,
};
